function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { debounce, memo, notUndefined, approxEqual } from "./utils.js";
var defaultKeyExtractor = function defaultKeyExtractor(index) {
  return index;
};
var defaultRangeExtractor = function defaultRangeExtractor(range) {
  var start = Math.max(range.startIndex - range.overscan, 0);
  var end = Math.min(range.endIndex + range.overscan, range.count - 1);
  var arr = [];
  for (var i = start; i <= end; i++) {
    arr.push(i);
  }
  return arr;
};
var observeElementRect = function observeElementRect(instance, cb) {
  var element = instance.scrollElement;
  if (!element) {
    return;
  }
  var targetWindow = instance.targetWindow;
  if (!targetWindow) {
    return;
  }
  var handler = function handler(rect) {
    var width = rect.width,
      height = rect.height;
    cb({
      width: Math.round(width),
      height: Math.round(height)
    });
  };
  handler(element.getBoundingClientRect());
  if (!targetWindow.ResizeObserver) {
    return function () {};
  }
  var observer = new targetWindow.ResizeObserver(function (entries) {
    var entry = entries[0];
    if (entry == null ? void 0 : entry.borderBoxSize) {
      var box = entry.borderBoxSize[0];
      if (box) {
        handler({
          width: box.inlineSize,
          height: box.blockSize
        });
        return;
      }
    }
    handler(element.getBoundingClientRect());
  });
  observer.observe(element, {
    box: "border-box"
  });
  return function () {
    observer.unobserve(element);
  };
};
var addEventListenerOptions = {
  passive: true
};
var observeWindowRect = function observeWindowRect(instance, cb) {
  var element = instance.scrollElement;
  if (!element) {
    return;
  }
  var handler = function handler() {
    cb({
      width: element.innerWidth,
      height: element.innerHeight
    });
  };
  handler();
  element.addEventListener("resize", handler, addEventListenerOptions);
  return function () {
    element.removeEventListener("resize", handler);
  };
};
var supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
var observeElementOffset = function observeElementOffset(instance, cb) {
  var element = instance.scrollElement;
  if (!element) {
    return;
  }
  var targetWindow = instance.targetWindow;
  if (!targetWindow) {
    return;
  }
  var offset = 0;
  var fallback = supportsScrollend ? function () {
    return void 0;
  } : debounce(targetWindow, function () {
    cb(offset, false);
  }, instance.options.isScrollingResetDelay);
  var createHandler = function createHandler(isScrolling) {
    return function () {
      var _instance$options = instance.options,
        horizontal = _instance$options.horizontal,
        isRtl = _instance$options.isRtl;
      offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
      fallback();
      cb(offset, isScrolling);
    };
  };
  var handler = createHandler(true);
  var endHandler = createHandler(false);
  endHandler();
  element.addEventListener("scroll", handler, addEventListenerOptions);
  element.addEventListener("scrollend", endHandler, addEventListenerOptions);
  return function () {
    element.removeEventListener("scroll", handler);
    element.removeEventListener("scrollend", endHandler);
  };
};
var observeWindowOffset = function observeWindowOffset(instance, cb) {
  var element = instance.scrollElement;
  if (!element) {
    return;
  }
  var targetWindow = instance.targetWindow;
  if (!targetWindow) {
    return;
  }
  var offset = 0;
  var fallback = supportsScrollend ? function () {
    return void 0;
  } : debounce(targetWindow, function () {
    cb(offset, false);
  }, instance.options.isScrollingResetDelay);
  var createHandler = function createHandler(isScrolling) {
    return function () {
      offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
      fallback();
      cb(offset, isScrolling);
    };
  };
  var handler = createHandler(true);
  var endHandler = createHandler(false);
  endHandler();
  element.addEventListener("scroll", handler, addEventListenerOptions);
  element.addEventListener("scrollend", endHandler, addEventListenerOptions);
  return function () {
    element.removeEventListener("scroll", handler);
    element.removeEventListener("scrollend", endHandler);
  };
};
var measureElement = function measureElement(element, entry, instance) {
  if (entry == null ? void 0 : entry.borderBoxSize) {
    var box = entry.borderBoxSize[0];
    if (box) {
      var size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
      return size;
    }
  }
  return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
var windowScroll = function windowScroll(offset, _ref, instance) {
  var _b$call;
  var _ref$adjustments = _ref.adjustments,
    adjustments = _ref$adjustments === void 0 ? 0 : _ref$adjustments,
    behavior = _ref.behavior;
  var _a, _b;
  var toOffset = offset + adjustments;
  (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null ? void 0 : _b.call(_a, (_b$call = {}, _defineProperty(_b$call, instance.options.horizontal ? "left" : "top", toOffset), _defineProperty(_b$call, "behavior", behavior), _b$call));
};
var elementScroll = function elementScroll(offset, _ref2, instance) {
  var _b$call2;
  var _ref2$adjustments = _ref2.adjustments,
    adjustments = _ref2$adjustments === void 0 ? 0 : _ref2$adjustments,
    behavior = _ref2.behavior;
  var _a, _b;
  var toOffset = offset + adjustments;
  (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null ? void 0 : _b.call(_a, (_b$call2 = {}, _defineProperty(_b$call2, instance.options.horizontal ? "left" : "top", toOffset), _defineProperty(_b$call2, "behavior", behavior), _b$call2));
};
var Virtualizer = /*#__PURE__*/_createClass(function Virtualizer(opts) {
  var _this = this;
  _classCallCheck(this, Virtualizer);
  this.unsubs = [];
  this.scrollElement = null;
  this.targetWindow = null;
  this.isScrolling = false;
  this.scrollToIndexTimeoutId = null;
  this.measurementsCache = [];
  this.itemSizeCache = /* @__PURE__ */new Map();
  this.pendingMeasuredCacheIndexes = [];
  this.scrollRect = null;
  this.scrollOffset = null;
  this.scrollDirection = null;
  this.scrollAdjustments = 0;
  this.elementsCache = /* @__PURE__ */new Map();
  this.observer = /* @__PURE__ */function () {
    var _ro = null;
    var get = function get() {
      if (_ro) {
        return _ro;
      }
      if (!_this.targetWindow || !_this.targetWindow.ResizeObserver) {
        return null;
      }
      return _ro = new _this.targetWindow.ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          _this._measureElement(entry.target, entry);
        });
      });
    };
    return {
      disconnect: function disconnect() {
        var _a;
        return (_a = get()) == null ? void 0 : _a.disconnect();
      },
      observe: function observe(target) {
        var _a;
        return (_a = get()) == null ? void 0 : _a.observe(target, {
          box: "border-box"
        });
      },
      unobserve: function unobserve(target) {
        var _a;
        return (_a = get()) == null ? void 0 : _a.unobserve(target);
      }
    };
  }();
  this.range = null;
  this.setOptions = function (opts2) {
    Object.entries(opts2).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];
      if (typeof value === "undefined") delete opts2[key];
    });
    _this.options = _objectSpread({
      debug: false,
      initialOffset: 0,
      overscan: 1,
      paddingStart: 0,
      paddingEnd: 0,
      scrollPaddingStart: 0,
      scrollPaddingEnd: 0,
      horizontal: false,
      getItemKey: defaultKeyExtractor,
      rangeExtractor: defaultRangeExtractor,
      onChange: function onChange() {},
      measureElement: measureElement,
      initialRect: {
        width: 0,
        height: 0
      },
      scrollMargin: 0,
      gap: 0,
      indexAttribute: "data-index",
      initialMeasurementsCache: [],
      lanes: 1,
      isScrollingResetDelay: 150,
      enabled: true,
      isRtl: false
    }, opts2);
  };
  this.notify = function (sync) {
    var _a, _b;
    (_b = (_a = _this.options).onChange) == null ? void 0 : _b.call(_a, _this, sync);
  };
  this.maybeNotify = memo(function () {
    _this.calculateRange();
    return [_this.isScrolling, _this.range ? _this.range.startIndex : null, _this.range ? _this.range.endIndex : null];
  }, function (isScrolling) {
    _this.notify(isScrolling);
  }, {
    key: process.env.NODE_ENV !== "production" && "maybeNotify",
    debug: function debug() {
      return _this.options.debug;
    },
    initialDeps: [this.isScrolling, this.range ? this.range.startIndex : null, this.range ? this.range.endIndex : null]
  });
  this.cleanup = function () {
    _this.unsubs.filter(Boolean).forEach(function (d) {
      return d();
    });
    _this.unsubs = [];
    _this.scrollElement = null;
    _this.targetWindow = null;
    _this.observer.disconnect();
    _this.elementsCache.clear();
  };
  this._didMount = function () {
    return function () {
      _this.cleanup();
    };
  };
  this._willUpdate = function () {
    var _a;
    var scrollElement = _this.options.enabled ? _this.options.getScrollElement() : null;
    if (_this.scrollElement !== scrollElement) {
      _this.cleanup();
      if (!scrollElement) {
        _this.maybeNotify();
        return;
      }
      _this.scrollElement = scrollElement;
      if (_this.scrollElement && "ownerDocument" in _this.scrollElement) {
        _this.targetWindow = _this.scrollElement.ownerDocument.defaultView;
      } else {
        var _ref5;
        _this.targetWindow = (_ref5 = (_a = _this.scrollElement) == null ? void 0 : _a.window) !== null && _ref5 !== void 0 ? _ref5 : null;
      }
      _this._scrollToOffset(_this.getScrollOffset(), {
        adjustments: void 0,
        behavior: void 0
      });
      _this.unsubs.push(_this.options.observeElementRect(_this, function (rect) {
        _this.scrollRect = rect;
        _this.maybeNotify();
      }));
      _this.unsubs.push(_this.options.observeElementOffset(_this, function (offset, isScrolling) {
        _this.scrollAdjustments = 0;
        _this.scrollDirection = isScrolling ? _this.getScrollOffset() < offset ? "forward" : "backward" : null;
        _this.scrollOffset = offset;
        _this.isScrolling = isScrolling;
        _this.maybeNotify();
      }));
    }
  };
  this.getSize = function () {
    var _this$scrollRect;
    if (!_this.options.enabled) {
      _this.scrollRect = null;
      return 0;
    }
    _this.scrollRect = (_this$scrollRect = _this.scrollRect) !== null && _this$scrollRect !== void 0 ? _this$scrollRect : _this.options.initialRect;
    return _this.scrollRect[_this.options.horizontal ? "width" : "height"];
  };
  this.getScrollOffset = function () {
    var _this$scrollOffset;
    if (!_this.options.enabled) {
      _this.scrollOffset = null;
      return 0;
    }
    _this.scrollOffset = (_this$scrollOffset = _this.scrollOffset) !== null && _this$scrollOffset !== void 0 ? _this$scrollOffset : typeof _this.options.initialOffset === "function" ? _this.options.initialOffset() : _this.options.initialOffset;
    return _this.scrollOffset;
  };
  this.getFurthestMeasurement = function (measurements, index) {
    var furthestMeasurementsFound = /* @__PURE__ */new Map();
    var furthestMeasurements = /* @__PURE__ */new Map();
    for (var m = index - 1; m >= 0; m--) {
      var measurement = measurements[m];
      if (furthestMeasurementsFound.has(measurement.lane)) {
        continue;
      }
      var previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
      if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) {
        furthestMeasurements.set(measurement.lane, measurement);
      } else if (measurement.end < previousFurthestMeasurement.end) {
        furthestMeasurementsFound.set(measurement.lane, true);
      }
      if (furthestMeasurementsFound.size === _this.options.lanes) {
        break;
      }
    }
    return furthestMeasurements.size === _this.options.lanes ? Array.from(furthestMeasurements.values()).sort(function (a, b) {
      if (a.end === b.end) {
        return a.index - b.index;
      }
      return a.end - b.end;
    })[0] : void 0;
  };
  this.getMeasurementOptions = memo(function () {
    return [_this.options.count, _this.options.paddingStart, _this.options.scrollMargin, _this.options.getItemKey, _this.options.enabled];
  }, function (count, paddingStart, scrollMargin, getItemKey, enabled) {
    _this.pendingMeasuredCacheIndexes = [];
    return {
      count: count,
      paddingStart: paddingStart,
      scrollMargin: scrollMargin,
      getItemKey: getItemKey,
      enabled: enabled
    };
  }, {
    key: false
  });
  this.getMeasurements = memo(function () {
    return [_this.getMeasurementOptions(), _this.itemSizeCache];
  }, function (_ref6, itemSizeCache) {
    var count = _ref6.count,
      paddingStart = _ref6.paddingStart,
      scrollMargin = _ref6.scrollMargin,
      getItemKey = _ref6.getItemKey,
      enabled = _ref6.enabled;
    if (!enabled) {
      _this.measurementsCache = [];
      _this.itemSizeCache.clear();
      return [];
    }
    if (_this.measurementsCache.length === 0) {
      _this.measurementsCache = _this.options.initialMeasurementsCache;
      _this.measurementsCache.forEach(function (item) {
        _this.itemSizeCache.set(item.key, item.size);
      });
    }
    var min = _this.pendingMeasuredCacheIndexes.length > 0 ? Math.min.apply(Math, _toConsumableArray(_this.pendingMeasuredCacheIndexes)) : 0;
    _this.pendingMeasuredCacheIndexes = [];
    var measurements = _this.measurementsCache.slice(0, min);
    for (var i = min; i < count; i++) {
      var key = getItemKey(i);
      var furthestMeasurement = _this.options.lanes === 1 ? measurements[i - 1] : _this.getFurthestMeasurement(measurements, i);
      var start = furthestMeasurement ? furthestMeasurement.end + _this.options.gap : paddingStart + scrollMargin;
      var measuredSize = itemSizeCache.get(key);
      var size = typeof measuredSize === "number" ? measuredSize : _this.options.estimateSize(i);
      var end = start + size;
      var lane = furthestMeasurement ? furthestMeasurement.lane : i % _this.options.lanes;
      measurements[i] = {
        index: i,
        start: start,
        size: size,
        end: end,
        key: key,
        lane: lane
      };
    }
    _this.measurementsCache = measurements;
    return measurements;
  }, {
    key: process.env.NODE_ENV !== "production" && "getMeasurements",
    debug: function debug() {
      return _this.options.debug;
    }
  });
  this.calculateRange = memo(function () {
    return [_this.getMeasurements(), _this.getSize(), _this.getScrollOffset()];
  }, function (measurements, outerSize, scrollOffset) {
    return _this.range = measurements.length > 0 && outerSize > 0 ? calculateRange({
      measurements: measurements,
      outerSize: outerSize,
      scrollOffset: scrollOffset
    }) : null;
  }, {
    key: process.env.NODE_ENV !== "production" && "calculateRange",
    debug: function debug() {
      return _this.options.debug;
    }
  });
  this.getIndexes = memo(function () {
    return [_this.options.rangeExtractor, _this.calculateRange(), _this.options.overscan, _this.options.count];
  }, function (rangeExtractor, range, overscan, count) {
    return range === null ? [] : rangeExtractor({
      startIndex: range.startIndex,
      endIndex: range.endIndex,
      overscan: overscan,
      count: count
    });
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function debug() {
      return _this.options.debug;
    }
  });
  this.indexFromElement = function (node) {
    var attributeName = _this.options.indexAttribute;
    var indexStr = node.getAttribute(attributeName);
    if (!indexStr) {
      console.warn("Missing attribute name '".concat(attributeName, "={index}' on measured element."));
      return -1;
    }
    return parseInt(indexStr, 10);
  };
  this._measureElement = function (node, entry) {
    var index = _this.indexFromElement(node);
    var item = _this.measurementsCache[index];
    if (!item) {
      return;
    }
    var key = item.key;
    var prevNode = _this.elementsCache.get(key);
    if (prevNode !== node) {
      if (prevNode) {
        _this.observer.unobserve(prevNode);
      }
      _this.observer.observe(node);
      _this.elementsCache.set(key, node);
    }
    if (node.isConnected) {
      _this.resizeItem(index, _this.options.measureElement(node, entry, _this));
    }
  };
  this.resizeItem = function (index, size) {
    var _this$itemSizeCache$g;
    var item = _this.measurementsCache[index];
    if (!item) {
      return;
    }
    var itemSize = (_this$itemSizeCache$g = _this.itemSizeCache.get(item.key)) !== null && _this$itemSizeCache$g !== void 0 ? _this$itemSizeCache$g : item.size;
    var delta = size - itemSize;
    if (delta !== 0) {
      if (_this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? _this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, _this) : item.start < _this.getScrollOffset() + _this.scrollAdjustments) {
        if (process.env.NODE_ENV !== "production" && _this.options.debug) {
          console.info("correction", delta);
        }
        _this._scrollToOffset(_this.getScrollOffset(), {
          adjustments: _this.scrollAdjustments += delta,
          behavior: void 0
        });
      }
      _this.pendingMeasuredCacheIndexes.push(item.index);
      _this.itemSizeCache = new Map(_this.itemSizeCache.set(item.key, size));
      _this.notify(false);
    }
  };
  this.measureElement = function (node) {
    if (!node) {
      _this.elementsCache.forEach(function (cached, key) {
        if (!cached.isConnected) {
          _this.observer.unobserve(cached);
          _this.elementsCache.delete(key);
        }
      });
      return;
    }
    _this._measureElement(node, void 0);
  };
  this.getVirtualItems = memo(function () {
    return [_this.getIndexes(), _this.getMeasurements()];
  }, function (indexes, measurements) {
    var virtualItems = [];
    for (var k = 0, len = indexes.length; k < len; k++) {
      var i = indexes[k];
      var measurement = measurements[i];
      virtualItems.push(measurement);
    }
    return virtualItems;
  }, {
    key: process.env.NODE_ENV !== "production" && "getVirtualItems",
    debug: function debug() {
      return _this.options.debug;
    }
  });
  this.getVirtualItemForOffset = function (offset) {
    var measurements = _this.getMeasurements();
    if (measurements.length === 0) {
      return void 0;
    }
    return notUndefined(measurements[findNearestBinarySearch(0, measurements.length - 1, function (index) {
      return notUndefined(measurements[index]).start;
    }, offset)]);
  };
  this.getOffsetForAlignment = function (toOffset, align) {
    var size = _this.getSize();
    var scrollOffset = _this.getScrollOffset();
    if (align === "auto") {
      if (toOffset <= scrollOffset) {
        align = "start";
      } else if (toOffset >= scrollOffset + size) {
        align = "end";
      } else {
        align = "start";
      }
    }
    if (align === "start") {
      toOffset = toOffset;
    } else if (align === "end") {
      toOffset = toOffset - size;
    } else if (align === "center") {
      toOffset = toOffset - size / 2;
    }
    var scrollSizeProp = _this.options.horizontal ? "scrollWidth" : "scrollHeight";
    var scrollSize = _this.scrollElement ? "document" in _this.scrollElement ? _this.scrollElement.document.documentElement[scrollSizeProp] : _this.scrollElement[scrollSizeProp] : 0;
    var maxOffset = scrollSize - size;
    return Math.max(Math.min(maxOffset, toOffset), 0);
  };
  this.getOffsetForIndex = function (index) {
    var align = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "auto";
    index = Math.max(0, Math.min(index, _this.options.count - 1));
    var item = _this.measurementsCache[index];
    if (!item) {
      return void 0;
    }
    var size = _this.getSize();
    var scrollOffset = _this.getScrollOffset();
    if (align === "auto") {
      if (item.end >= scrollOffset + size - _this.options.scrollPaddingEnd) {
        align = "end";
      } else if (item.start <= scrollOffset + _this.options.scrollPaddingStart) {
        align = "start";
      } else {
        return [scrollOffset, align];
      }
    }
    var toOffset = align === "end" ? item.end + _this.options.scrollPaddingEnd : item.start - _this.options.scrollPaddingStart;
    return [_this.getOffsetForAlignment(toOffset, align), align];
  };
  this.isDynamicMode = function () {
    return _this.elementsCache.size > 0;
  };
  this.cancelScrollToIndex = function () {
    if (_this.scrollToIndexTimeoutId !== null && _this.targetWindow) {
      _this.targetWindow.clearTimeout(_this.scrollToIndexTimeoutId);
      _this.scrollToIndexTimeoutId = null;
    }
  };
  this.scrollToOffset = function (toOffset) {
    var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref7$align = _ref7.align,
      align = _ref7$align === void 0 ? "start" : _ref7$align,
      behavior = _ref7.behavior;
    _this.cancelScrollToIndex();
    if (behavior === "smooth" && _this.isDynamicMode()) {
      console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
    }
    _this._scrollToOffset(_this.getOffsetForAlignment(toOffset, align), {
      adjustments: void 0,
      behavior: behavior
    });
  };
  this.scrollToIndex = function (index) {
    var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref8$align = _ref8.align,
      initialAlign = _ref8$align === void 0 ? "auto" : _ref8$align,
      behavior = _ref8.behavior;
    index = Math.max(0, Math.min(index, _this.options.count - 1));
    _this.cancelScrollToIndex();
    if (behavior === "smooth" && _this.isDynamicMode()) {
      console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
    }
    var offsetAndAlign = _this.getOffsetForIndex(index, initialAlign);
    if (!offsetAndAlign) return;
    var _offsetAndAlign = _slicedToArray(offsetAndAlign, 2),
      offset = _offsetAndAlign[0],
      align = _offsetAndAlign[1];
    _this._scrollToOffset(offset, {
      adjustments: void 0,
      behavior: behavior
    });
    if (behavior !== "smooth" && _this.isDynamicMode() && _this.targetWindow) {
      _this.scrollToIndexTimeoutId = _this.targetWindow.setTimeout(function () {
        _this.scrollToIndexTimeoutId = null;
        var elementInDOM = _this.elementsCache.has(_this.options.getItemKey(index));
        if (elementInDOM) {
          var _notUndefined = notUndefined(_this.getOffsetForIndex(index, align)),
            _notUndefined2 = _slicedToArray(_notUndefined, 1),
            latestOffset = _notUndefined2[0];
          if (!approxEqual(latestOffset, _this.getScrollOffset())) {
            _this.scrollToIndex(index, {
              align: align,
              behavior: behavior
            });
          }
        } else {
          _this.scrollToIndex(index, {
            align: align,
            behavior: behavior
          });
        }
      });
    }
  };
  this.scrollBy = function (delta) {
    var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      behavior = _ref9.behavior;
    _this.cancelScrollToIndex();
    if (behavior === "smooth" && _this.isDynamicMode()) {
      console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
    }
    _this._scrollToOffset(_this.getScrollOffset() + delta, {
      adjustments: void 0,
      behavior: behavior
    });
  };
  this.getTotalSize = function () {
    var _a;
    var measurements = _this.getMeasurements();
    var end;
    if (measurements.length === 0) {
      end = _this.options.paddingStart;
    } else {
      var _ref10;
      end = _this.options.lanes === 1 ? (_ref10 = (_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) !== null && _ref10 !== void 0 ? _ref10 : 0 : Math.max.apply(Math, _toConsumableArray(measurements.slice(-_this.options.lanes).map(function (m) {
        return m.end;
      })));
    }
    return end - _this.options.scrollMargin + _this.options.paddingEnd;
  };
  this._scrollToOffset = function (offset, _ref11) {
    var adjustments = _ref11.adjustments,
      behavior = _ref11.behavior;
    _this.options.scrollToFn(offset, {
      behavior: behavior,
      adjustments: adjustments
    }, _this);
  };
  this.measure = function () {
    _this.itemSizeCache = /* @__PURE__ */new Map();
    _this.notify(false);
  };
  this.setOptions(opts);
});
var findNearestBinarySearch = function findNearestBinarySearch(low, high, getCurrentValue, value) {
  while (low <= high) {
    var middle = (low + high) / 2 | 0;
    var currentValue = getCurrentValue(middle);
    if (currentValue < value) {
      low = middle + 1;
    } else if (currentValue > value) {
      high = middle - 1;
    } else {
      return middle;
    }
  }
  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};
function calculateRange(_ref12) {
  var measurements = _ref12.measurements,
    outerSize = _ref12.outerSize,
    scrollOffset = _ref12.scrollOffset;
  var count = measurements.length - 1;
  var getOffset = function getOffset(index) {
    return measurements[index].start;
  };
  var startIndex = findNearestBinarySearch(0, count, getOffset, scrollOffset);
  var endIndex = startIndex;
  while (endIndex < count && measurements[endIndex].end < scrollOffset + outerSize) {
    endIndex++;
  }
  return {
    startIndex: startIndex,
    endIndex: endIndex
  };
}
export { Virtualizer, approxEqual, debounce, defaultKeyExtractor, defaultRangeExtractor, elementScroll, measureElement, memo, notUndefined, observeElementOffset, observeElementRect, observeWindowOffset, observeWindowRect, windowScroll };